import * as angular from "angular";

export interface Franchise {
    id: string;
    name: string;
    imageUrl: string;
    path: string;
    editions: Edition[];
}

export interface Edition {
    id: string;
    name: string;
    path: string;
}

export class FranchiseResource {
    public static $inject = ["$q"];
    constructor(private $q: angular.IQService) {
    }

    public getAllFranchises(): angular.IPromise<Franchise[]> {
        return this.$q.when([
            {
                id: '4',
                name: 'Intern Franchise',
                path: '/play/intern/',
                imageUrl: 'http://gfx.esl.eu/media/cm/2014/franchise/esl_franchise.jpg',
                editions: [
                    {
                        id: '107',
                        name: 'CS:GO',
                        path: '/play/intern/csgo/'
                    },
                    {
                        id: '305',
                        name: 'Hearthstone',
                        path: '/play/intern/hearthstone/'
                    },
                    {
                        id: '304',
                        name: 'Rocket League',
                        path: '/play/intern/rocketleague/'
                    }
                ]
            },
            {
                id: '13',
                name: 'Hearthstone',
                path: '/play/hearthstone/',
                imageUrl: 'http://gfx.esl.eu/media/cm/2014/franchise/hearthstone.jpg',
                editions: [
                    {
                        id: '120',
                        name: 'Americas',
                        path: '/play/hearthstone/americas/'
                    },
                    {
                        id: '214',
                        name: 'Asia',
                        path: '/play/hearthstone/asia/'
                    },
                    {
                        id: '8',
                        name: 'Europe',
                        path: '/play/hearthstone/europe/'
                    }
                ]
            },
            {
                id: '56',
                name: 'Mortal Kombat',
                path: '/play/mortalkombat/',
                imageUrl: 'http://gfx.esl.eu/media/cm/2015/franchise/mortalkombat.jpg',
                editions: [
                    {
                        id: '222',
                        name: 'CIS',
                        path: '/play/mortalkombat/cis/'
                    },
                    {
                        id: '219',
                        name: 'Europe',
                        path: '/play/mortalkombat/europe/'
                    },
                    {
                        id: '218',
                        name: 'North America',
                        path: '/play/mortalkombat/north-america/'
                    }
                ]
            },
            {
                id: '11',
                name: 'FIFA',
                path: '/play/fifa/',
                imageUrl: 'http://gfx.esl.eu/media/cm/2014/franchise/fifa.jpg',
                editions: [
                    {
                        id: '13',
                        name: 'PC',
                        path: '/play/fifa/pc/'
                    },
                    {
                        id: '6',
                        name: 'PlayStation',
                        path: '/play/fifa/playstation/'
                    },
                    {
                        id: '12',
                        name: 'Xbox',
                        path: '/play/fifa/xbox/'
                    }
                ]

            },
            {
                id: '76',
                name: 'HEX: Shards of Fate',
                path: '/play/hexshardsoffate/',
                imageUrl: 'http://gfx.esl.eu/media/cm/2015/franchise/hex.jpg',
                editions: [
                    {
                        id: '280',
                        name: 'Europe',
                        path: '/play/hexshardsoffate/europe/'
                    },
                    {
                        id: '281',
                        name: 'North America',
                        path: '/play/hexshardsoffate/north-america/'
                    },
                ]

            },
            {
                id: '79',
                name: 'Project CARS',
                path: '/play/projectcars/',
                imageUrl: 'http://gfx.esl.eu/media/cm/2015/franchise/projectcars.jpg',
                editions: [
                    {
                        id: '292',
                        name: 'PC',
                        path: '/play/projectcars/pc/'
                    },
                    {
                        id: '293',
                        name: 'PlayStation',
                        path: '/play/projectcars/playstation/'
                    },
                    {
                        id: '294',
                        name: 'Xbox',
                        path: '/play/projectcars/xbox/'
                    }
                ]

            },
            {
                id: '1',
                name: 'StarCraft',
                path: '/play/starcraft/',
                imageUrl: 'http://gfx.esl.eu/media/cm/2014/franchise/starcraft.jpg',
                editions: [
                    {
                        id: '1',
                        name: 'Global',
                        path: '/play/starcraft/global/'
                    }
                ]

            }
        ]);
    }
}
